export default __webpack_public_path__ + "static/media/1.26656544.jpg";